import getLignesCommandesWithReferenceEcheancier
  from '@/services/commande/echeancierFacturation/getLignesCommandesWithReferenceEcheancier';

export function checkMontantEcheancierAuto(echeancier, lignesCommande) {
  echeancier.montant = getLignesCommandesWithReferenceEcheancier(
    lignesCommande, echeancier.referenceEcheancier,
  ).map((ligne) => { return ligne.totalHtAvecLigneRemise; })
    .reduce((montantTotal, montant) => montantTotal + montant);
}

export function checkMontantAllEcheancierAuto(commande) {
  const echeanciers = commande.echeanciers.filter((echeancier) => {
    return echeancier.quantitePeriodicite === 0;
  });
  echeanciers.forEach((echeancier) => {
    checkMontantEcheancierAuto(echeancier, commande.lignesCommande);
  });
}
